import { View } from "react-native";
import React from "react";
import { TenantSubdomain } from "features/types";
import TeamBannerComponent from "../teamBanners";

interface TeamBannerProps {
  tenantSubdomain: TenantSubdomain | null;
}

const TeamBanner: React.FC<TeamBannerProps> = ({ tenantSubdomain }) => {
  if (tenantSubdomain === null) return null;

  const TeamComponent = TeamBannerComponent[tenantSubdomain];

  return <View>{TeamComponent ? <TeamComponent /> : null}</View>;
};

export default TeamBanner;
